import { SaveSiteLayer } from "react-migration/domains/sites/typings";
import { routedClient } from "react-migration/lib/persistence/apollo";
import CREATE_SITES from "../graphql/createSites.gql";
import CREATE_SITES_DRY_RUN from "../graphql/createSitesDryRun.gql";
import { LogEventCreatedSiteEventLocation } from "react-migration/lib/util/logEventV2";
import { CreateSitesQueryData, CreateSitesQueryVariables } from "../useSaveSiteMutation";
import type { Site } from "../typings/Site";

type SaveSitesBulkParams = {
  layer: SaveSiteLayer;
  sites: Site[];
  stageId?: string;
  source: LogEventCreatedSiteEventLocation;
};
export const saveSitesBulk = async ({ sites, stageId }: SaveSitesBulkParams) => {
  const promises = sites.map(async (site) => {
    const res = await routedClient.mutate<CreateSitesQueryData, CreateSitesQueryVariables>({
      mutation: CREATE_SITES,
      variables: {
        sites: [site],
        stageId,
      },
      refetchQueries: [
        {
          query: CREATE_SITES_DRY_RUN,
          variables: {
            sites: [site],
            siteMatchType: "EXACT",
          },
        },
      ],
    });
    if (!res.data?.createSites?.[0].saved_site?._id) {
      throw new Error("Not all sites were saved");
    }

    return res;
  });

  return await Promise.all(promises);
};
